import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTRPCAPI } from '../../../../trpc/trpc';
import { songsBrewStateOf, SongsBrewStatus } from './useSongsBrewState';

/**
 * Writes the answer of a SongsBrew call into every cached `newsletter.getState` answer (Home, the
 * welcome and Settings read it with different inputs), then marks them stale with no refetch now.
 * The next mount or focus reads the platform again.
 */
export function useWriteSongsBrewStatus(): (status: SongsBrewStatus) => void {
  const trpcAPI = useTRPCAPI();
  const queryClient = useQueryClient();

  return useCallback(
    (status: SongsBrewStatus) => {
      const queryKey = trpcAPI.newsletter.getState.pathKey();
      queryClient.setQueriesData({ queryKey }, (old: unknown) =>
        songsBrewStateOf(old) === null ? old : { ...(old as object), status }
      );
      queryClient.invalidateQueries({ queryKey, refetchType: 'none' }).catch(console.error);
    },
    [queryClient, trpcAPI]
  );
}
